import { useQuery } from "@tanstack/react-query";

import { ErrorPage } from "@/components/Error/ErrorPage";
import { alertsMutations } from "@/queries/alerts/mutations";
import { useAlertQueries } from "@/queries/alerts/queryOptions";

import { AlertSettings, type AlertSettingsProps } from "./AlertSettings";

export function SettingsAlertsPage(): React.ReactNode {
  const alertQueries = useAlertQueries();

  const { data: alerts, isFetching: isFetchingAlerts, error: alertsError } = useQuery(alertQueries.list());

  const createNumberOfLikesAlert = alertsMutations.useCreateNumberOfLikesAlert();
  const createNumberOfCommentsAlert = alertsMutations.useCreateNumberOfCommentsAlert();
  const createPostKeywordsAlert = alertsMutations.useCreatePostKeywordsAlert();
  const createCommentKeywordsAlert = alertsMutations.useCreateCommentKeywordsAlert();
  const editNumberOfLikesAlert = alertsMutations.useEditNumberOfLikesAlert();
  const editNumberOfCommentsAlert = alertsMutations.useEditNumberOfCommentsAlert();
  const editPostKeywordsAlert = alertsMutations.useEditPostKeywordsAlert();
  const editCommentKeywordsAlert = alertsMutations.useEditCommentKeywordsAlert();

  const error = alertsError;
  if (error) {
    return <ErrorPage error={error} />;
  }

  const contentProps: AlertSettingsProps = {
    alerts: alerts ?? {
      numberOfCommentsAlerts: [],
      numberOfLikesAlerts: [],
      postKeywordAlerts: [],
      commentKeywordAlerts: [],
    },
    isLoading: isFetchingAlerts,
    createLikeAlert: createNumberOfLikesAlert.mutateAsync,
    createCommentAlert: createNumberOfCommentsAlert.mutateAsync,
    createPostKeywordsAlert: createPostKeywordsAlert.mutateAsync,
    createCommentKeywordsAlert: createCommentKeywordsAlert.mutateAsync,
    editLikeAlert: editNumberOfLikesAlert.mutateAsync,
    editCommentAlert: editNumberOfCommentsAlert.mutateAsync,
    editPostKeywordsAlert: editPostKeywordsAlert.mutateAsync,
    editCommentKeywordsAlert: editCommentKeywordsAlert.mutateAsync,
  };

  return <AlertSettings {...contentProps} />;
}
